module.exports = __webpack_public_path__ + "img/fc.ad1a18f0.png";